import {
  BanknoteArrowDown,
  BarChart3,
  Bell,
  Building2,
  ClipboardCheck,
  ClipboardList,
  Coins,
  FileText,
  Folder,
  Layers3,
  LayoutDashboard,
  Mail,
  Megaphone,
  MessageCircle,
  Receipt,
  Settings,
  ShieldCheck,
  ShoppingCart,
  UserCheck,
  UserPlus,
  Users,
} from "lucide-react";

export type NavItem = {
  title: string;
  url: string;
  icon?: React.ComponentType<{ className?: string }>;
  action?: React.ReactNode;
  badge?: number;
};

export const adminNavMain: NavItem[] = [
  { title: "Dashboard", url: "/admin/dashboard", icon: LayoutDashboard },
  { title: "Approvals", url: "/admin/founder-review", icon: ClipboardCheck },
  { title: "Users", url: "/admin/users", icon: Users },
  { title: "Partners", url: "/admin/partners", icon: UserPlus },
  { title: "Buyers", url: "/admin/buyers", icon: UserCheck },
  { title: "Properties", url: "/admin/properties", icon: Building2 },
  { title: "Sales", url: "/admin/sales", icon: ShoppingCart },
  { title: "Refunds", url: "/admin/refunds", icon: BanknoteArrowDown },
  { title: "Commissions", url: "/admin/commissions", icon: Coins },
  { title: "WHT Ledger", url: "/admin/commissions/wht", icon: Receipt },
  { title: "Notifications", url: "/admin/notifications", icon: Bell },
  { title: "Messages", url: "/admin/messages", icon: MessageCircle },
];

export const accountantNavMain: NavItem[] = [
  { title: "Finance Overview", url: "/accountant", icon: LayoutDashboard },
  { title: "Reports", url: "/accountant/reports", icon: FileText },
  { title: "Analytics", url: "/accountant/analytics", icon: BarChart3 },
  { title: "Debt Recovery", url: "/accountant/debt-recovery", icon: BanknoteArrowDown },
  { title: "Sales Review", url: "/admin/sales", icon: ShoppingCart },
  { title: "Refunds", url: "/admin/refunds", icon: BanknoteArrowDown },
  { title: "Commissions", url: "/admin/commissions", icon: Coins },
  { title: "WHT Ledger", url: "/admin/commissions/wht", icon: Receipt },
  { title: "Notifications", url: "/accountant/notifications", icon: Bell },
];

export const accountantNavSecondary: NavItem[] = [
  { title: "Finance Settings", url: "/admin/settings", icon: Settings },
  { title: "Activity Log", url: "/admin/activity-log", icon: ClipboardList },
  { title: "Profile", url: "/profile", icon: UserCheck },
  { title: "Messages", url: "/accountant/messages", icon: MessageCircle },
];

export const adminNavSecondary: NavItem[] = [
  { title: "Analytics", url: "/admin/analytics", icon: BarChart3 },
  { title: "Templates", url: "/admin/document-templates", icon: Layers3 },
  { title: "Partner Banners", url: "/admin/partner-banners", icon: Megaphone },
  { title: "File Management", url: "/admin/file-management", icon: Folder },
  { title: "Debt Recovery", url: "/admin/debt-recovery", icon: BanknoteArrowDown },
  { title: "Reports", url: "/admin/reports", icon: FileText },
  { title: "Staff", url: "/admin/staff", icon: ShieldCheck },
  { title: "Roles", url: "/admin/roles", icon: ShieldCheck },
  { title: "Activity Log", url: "/admin/activity-log", icon: ClipboardList },
  { title: "Settings", url: "/admin/settings", icon: Settings },
];

export const partnerNavOverview: NavItem[] = [
  { title: "Home", url: "/partner/home", icon: LayoutDashboard },
  { title: "Inbox", url: "/partner/inbox", icon: Mail },
  { title: "Referrals", url: "/partner/referrals", icon: Users },
];

export const partnerNavDeals: NavItem[] = [
  { title: "Properties", url: "/partner/properties", icon: Building2 },
  { title: "Sales", url: "/partner/sales", icon: ShoppingCart },
  { title: "Buyers", url: "/partner/buyers", icon: UserCheck },
  { title: "Commissions", url: "/partner/commissions", icon: Coins },
];

export const partnerNavSecondary: NavItem[] = [];
